<script lang="ts">
  import { Icon } from 'svelte-materialify';
  import { mdiYoutube } from '@mdi/js';
</script>

<style>
  .quote {
    padding-top: 0;
    color: #444;
    font-size: 14px;
    font-style: italic;
  }
</style>


<h4 class="text-h4">Information</h4>

<p>
  <em>Etch A Skratch</em> is a tool to demonstrate <strong>TTM</strong> charts with visual and audio feedback.
</p>

<h6 class="text-h6">So, what's TTM then?</h6>

<blockquote class="quote">
Turntablist Transcription Methodology, or TTM, is a notation system for scratching and turntablism. The system was founded by John Carluccio in 1997. [..] It is an intuitive graphical representation of the movement of a record whilst performing with a turntable [...]
  <br/>
  – <a href="https://en.wikipedia.org/wiki/Turntablist_transcription_methodology">Wikipedia (Aug 2022)</a>
</blockquote>

<p>
  Probably best to understand with an example video:<br/>
  <a href="https://www.youtube.com/watch?v=wsKpqJ-g388">
    <Icon path={mdiYoutube} size="32px" />
    Rob Swift - TTM demo (youtube)
  </a>
</p>

<p>
  Find out more about TTM and it's history at the <a href="https://www.ttm-dj.com/" target="_blank">Official TTM website & Guide</a>.
</p>


<h6 class="text-h6">Etch a Skratch</h6>
<p>
  This tool mainly serves an educational purpose and tries to communicate the abstract concept of scratches. We display the record movement as strictly linear, which results in very unrealistic "robotic" sounding audio, but is a necessary simplification for this tool and helps to convey the basic concepts more easily.<br>
  The real art of scratching is defined by all the tiny variations of the record movement of course.
</p>

<p>
  The notation used in this tool is based on TTM, but focuses only on scratching. Therefore some parts of the original TTM notation are left out or simplified. For example, the record movement is always thought to be based on a single record rotation (think of a "skipless" scratch vinyl), as opposed to multiple rotations as it would be required for beat juggling. In the original TTM there's also a concept for multiple turntables playing at the same time and includes options to note down full compositions.
</p>


<h6 class="text-h6">Project background</h6>
<p>
  The original goal of this hobby project was only to have a library of basic scratch patterns with audio examples. But the current solution would also allow to have an editor in the future.
</p>
<p>
  It's still in early development phase and might not working in all browsers. When the audio and visuals are getting out-of-sync, try stopping and restarting.
</p>


<h6 class="text-h6">Special credits</h6>
<p>
  Big thanks to <a href="http://zuckell.com/" target="_blank" title="">Zuckell</a> for providing awesome beats! Check out his page for more info: <a href="http://zuckell.com/" target="_blank" title="">zuckell.com</a>.
</p>


<h6 class="text-h6">Build with</h6>
<ul>
  <li><a href="https://svelte.dev/">Svelte framework</a></li>
  <li><a href="https://svelte-materialify.vercel.app/">UI: svelte-materialify</a></li>
  <li><a href="https://materialdesignicons.com/">Icons: materialdesignicons</a></li>
  <li><a href="https://www.npmjs.com/package/audio-buffer-utils">WebAudio: audio-buffer-utils</a></li>
  <li><a href="https://apexcharts.com/">ApexCharts</a></li>
</ul>


